import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    resources: {
      en: {
        translation: {
          welcome: "Welcome",
          changeLanguage: "Change Language",
          visit_the_website: "Visit The website",
          registration_form: "Registration Form",
          adentalis_workshop: "Adentalis Workshop - AIDEC 2025 - Aleppo",
          visitor_information: "Participant Information as You Wish to Appear on The Certificate",
          full_name_in_english: "Full Name in English",
          full_name_is_required: "Full Name is Required",
          city: "City",
          city_is_required: "City is Required",
          please_select_one_of_cities: "Please Select One Of Cities",
          academic_level: "Academic Level",
          please_select_one_of_academic_level: "Please Select One Of Academic Level",
          contact_information: "Contact Information",
          mail: "Mail",
          please_enter_a_valid_mail: "Please Enter a Valid Mail (e.g. example@domain.com)",
          phone_number_is_required: "Phone Number is Required",
          fields_of_medical_interest: "Fields Of Medical Interest",
          medical_interests: "Medical Interests",
          please_select_at_least_one_area_of_interest: "Please Select at Least One Area Of Interest",
          please_check_your_email: "Please Check Your Email",
          workshops: "Workshops",
          please_select_at_least_one_of_workshops: "Please Select at Least One Of Workshops",
          for_student:"Please bring and show your university ID card or university registration receipt for students during the payment process at the union branches or at the Professional Practice Office in the Faculty of Dentistry.",
          please_check_the_box: "Please Check The Box",
          submit: "Submit",
          submitting: "Submitting",
          who_are_we: "Who Are We",
          description: "It is a British academy specialized in dentistry, leading the way in shaping the future of medical education through high-quality, evidence-based practical training programs.",
          contact_us: "Contact Us",
          location: "Damascus, Syria",
          copyright: "Copyright",
          developed: "Developed By AIGate. All Rights Reserved",
        }
      },
      ar: {
        translation: {
          welcome: "أهلا بك",
          changeLanguage: "تغيير اللغة",
          visit_the_website: "زيارة الموقع الرسمي",
          registration_form: "استمارة التسجيل",
          adentalis_workshop: "Adentalis Workshop - AIDEC 2025 - Aleppo",
          visitor_information: "معلومات المشترك كما ترغب بالظهور على الشهادة",
          full_name_in_english: "الاسم الكامل باللغة الأجنبية",
          full_name_is_required: "الاسم الكامل مطلوب",
          city: "المدينة",
          city_is_required: "المدينة مطلوبة",
          please_select_one_of_cities: "الرجاء اختيار واحدة من المدن",
          academic_level: "المستوى العلمي",
          please_select_one_of_academic_level: "الرجاء اختيار المستوى العلمي",
          contact_information: "معلومات التواصل",
          mail: "الايميل",
          please_enter_a_valid_mail: "يرجى إدخال بريد إلكتروني صالح (مثال: example@domain.com)",
          phone_number_is_required: "الرجاء ادخال رقم موبايل",
          fields_of_medical_interest: "مجالات الاهتمام الطبي",
          medical_interests: "الاهتمامات الطبية",
          please_select_at_least_one_area_of_interest: "الرجاء اختيار واحدة على الاقل من  مجالات الاهتمام",
          please_check_your_email: "الرجاء التحقق من البريد الالكتروني",
          workshops: "الورشات",
          please_select_at_least_one_of_workshops:"الرجاء اختيار واحدة على الاقل من الورشات",
          for_student: "يُرجى إرسال صورة البطاقة الجامعية أو وصل التسجيل بالجامعة للطلاب على رقم الواتس أب الخاص بالأكاديمية : 0944275742",
          please_check_the_box: "الرجاء تحديد مربع الملاحظة",
          submit: "تسجيل",
          submitting: "جاري التسجيل",
          who_are_we: "من نحن",
          description: `أكاديمية بريطانية متخصصة في طب الأسنان، رائدة في ابتكار مستقبل التعليم الطبي من خلال برامج تدريبية عملية عالية الجودة قائمة على الأدلة العلمية،`,
          contact_us: "اتصل بنا",
          location: "دمشق, سوريا",
          copyright: "حقوق النشر",
          developed: "تم تطويره من قبل AIGate. جميع الحقوق محفوظة",
        }
      }
    },
    interpolation: {
      escapeValue: false,
    }
  });

export default i18n;
